<template>
  <div class="container">
    <!-- 第一层 -->
    <div class="oneBox">
      <div class="posBox">
        <div class="titleBox">
          <div>微E检发展规模</div>
          <p>
            微E检医检平台上线至今，已覆盖至江苏、湖南、湖北、安徽、江西、
            四川、广东、河北、河南、福建、山东、北京、重庆等省市，
            并已计划拓展覆盖全国，可为基层医疗机构提供3000余项医学检验送检服务。
          </p>
        </div>
        <img src="../../../../assets/WEmap.png" alt="" style="width:736px;height:609px;">
      </div>
    </div>
    <!-- 第二层 -->
    <div class="twoBox">
      <div class="posBox">
        <div class="titleBox">“互联网+医学检验”新模式</div>
        <div class="bottomBox">
          <img
            src="../../../../assets/WEcomputer.png"
            alt=""
            style="width:756px;height:516px;margin:31px 31px 0 0 ;"
          >
          <div class="contentBox">
            <div class="content1">
              <div class="left">
                <img src="../../../../assets/WEicon1.png" alt="" style="width:38px;height:38px;">
              </div>
              <div class="right clearfix">
                <h3>六大功能</h3>
                <div class="text">
                  <div class="text1">
                    <p>智能检验功能</p>
                    <p>健康档案管理</p>
                  </div>
                  <div class="text1">
                    <p>用户权限管理</p>
                    <p>总检报告功能</p>
                  </div>
                  <div class="text1">
                    <p>统计查询功能</p>
                    <p>系统设置功能</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="content1">
              <div class="left">
                <img src="../../../../assets/WEicon2.png" alt="" style="width:38px;height:38px;">
              </div>
              <div class="right clearfix">
                <h3>增值服务</h3>
                <div class="text">
                  <div class="text1">
                    <p>诊所经营统计</p>
                    <p>医疗检验业务</p>
                  </div>
                  <div class="text1">
                    <p>健康档案存储</p>
                    <p>疾病风险评估</p>
                  </div>
                  <div class="text1">
                    <p>权威专家解读</p>
                    <p>健康指导干预</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="content2">
              <div class="left">
                <img src="../../../../assets/WEicon3.png" alt="" style="width:38px;height:38px;">
              </div>
              <div class="right clearfix">
                <h3>优势</h3>
                <div class="text">
                  <p>服务优势</p>
                  <span>提高医务人员的工作效率</span>
                  <span>提升服务质量和管理水平</span>
                  <span>提供更好的医疗体验</span>
                </div>
                <div class="text2">
                  <p>产品优势</p>
                  <div class="top">
                    <span>权威可靠的检验数据</span>
                    <span>检验项目库种类齐全</span>
                  </div>
                  <div class="bottom">
                    <span>海量医药学知识库</span>
                    <span>完善的运维管理体系</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第三层 -->
    <div class="threeBox">
      <div class="pos">
        <div class="topBox">
          <h3>业务流程</h3>
          <p>基于“健康云”服务概念，打造智能化的健康管理运营平台。提供专业、快捷、精准的检验服务，打造创新型医检上门服务模式，实现智慧移动医疗。</p>
        </div>
        <div class="contentBox">
          <h3>1.初诊、开单、采样</h3>
          <p>微E检为诊所提供等同于三甲医院水准的服务，协助诊</p>
          <p>所快速启动医学检验业务</p>
        </div>
        <div class="bottomBox">
          <div class="left">
            <h3>5.获取报告及解读支持</h3>
            <p>帮助诊所进行订单报告跟踪查询、客户健康管理等，同</p>
            <p>时我们的专业医疗团队提供具有针对性的检验报告解读</p>
            <p>支持，更好的服务受检者</p>
            <h3>4.权威专业的第三方实验室</h3>
            <p>全方位的检验服务对接，安全可靠的检测数据快速输出</p>
          </div>
          <div class="center">
            <img src="../../../../assets/WEwujiao.png" alt="">
          </div>
          <div class="right">
            <h3>2.一键下单</h3>
            <p>通过「微E检诊所端」进行一键下单，检验报告自动与患</p>
            <p>者病历连接</p>
            <h3>3.医疗冷链物流体系</h3>
            <p>微E检自建冷链物流团队，体系化的岗前培训，&nbsp;针对每</p>
            <p>一份样本，确保每一次的规范操作安全送达第三方独立</p>
            <p>医学实验室</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 第四层 -->
    <div class="fourBox">
      <div class="pos">
        <div class="left">
          <div class="leftBox1">
            <div class="leftBox1-a">
              <img src="../../../../assets/WEicon4.png" alt="" style="width:42px;height:42px;">
              <p>一站式检验流程</p>
            </div>
            <div class="leftBox1-a">
              <img src="../../../../assets/WEicon5.png" alt="" style="width:42px;height:42px;">
              <p>多维度数据对接</p>
            </div>
            <div class="leftBox1-a">
              <img src="../../../../assets/WEicon6.png" alt="" style="width:42px;height:42px;">
              <p>精细化统计管理</p>
            </div>
            <div class="leftBox1-a">
              <img src="../../../../assets/WEicon7.png" alt="" style="width:42px;height:42px;">
              <p>信息化增值服务</p>
            </div>
          </div>
          <div class="leftBox2">
            <div class="clickToWe">
              <div class="WEtext" @click="toWE">点击进入微E检</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="../../../../assets/WEMedical.png" alt="" style="width:644px;height:403px;">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {},
  methods: {
    toWE() {
      window.open('http://wehealth.hwason.cn/#/');
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  .oneBox {
    width: 100%;
    height: 838px;
    background: url('../../../../assets/WEbgc.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    .posBox {
      width: 1137px;
      height: 745px;
      text-align: center;
      // border: 1px solid red;
      .titleBox {
        text-align: center;
        margin-bottom: 12px;
        div {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 104, 183, 1);
        }
        p {
          font-size: 20px;
          font-family: Microsoft YaHei;
          color: #333333;
          margin-top: 40px;
          line-height: 34px;
        }
      }
    }
  }
  .twoBox {
    width: 100%;
    height: 730px;
    background-color: #f1f6f7;
    display: flex;
    justify-content: center;
    align-items: center;
    .posBox {
      width: 1478px;
      height: 632px;
      margin-top: 48px;
      // border: 1px solid red;
      text-align: center;
      .titleBox {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(0, 104, 183, 1);
        margin-bottom: 50px;
      }
      .bottomBox {
        display: flex;
        justify-content: space-between;
        .contentBox {
          width: 710px;
          height: 508px;
          // border: 1px solid red;
          .content1 {
            width: 603px;
            height: 100px;
            display: flex;
            margin-bottom: 30px;
            .left {
            }
            .right {
              width: 650px;
              margin: 6px 0 0 19px;
              h3 {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(0, 104, 183, 1);
                float: left;
                margin-bottom: 3px;
              }
              .text {
                width: 650px;
                display: flex;
                .text1 {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 36px;
                  color: rgba(102, 102, 102, 1);
                  margin-right: 115px;
                }
              }
            }
          }
          .content2 {
            width: 603px;
            height: 100px;
            display: flex;
            margin-bottom: 21px;
            .left {
            }
            .right {
              width: 650px;
              margin: 6px 0 0 19px;
              h3 {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(0, 104, 183, 1);
                text-align: left;
                margin-bottom: 10px;
                width: 100%;
              }
              .text {
                width: 650px;
                text-align: left;
                margin-bottom: 20px;
                p {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  margin-bottom: 12px;
                }
                span {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #666;
                  margin-right: 30px;
                }
              }
              .text2 {
                width: 650px;
                text-align: left;
                p {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  margin-bottom: 12px;
                }
                .top {
                  margin-bottom: 13px;
                  span {
                    &:nth-child(1) {
                      margin-right: 62px;
                    }
                  }
                }
                .bottom {
                  span {
                    &:nth-child(1) {
                      margin-right: 78px;
                    }
                  }
                }
                span {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #666;
                  margin-right: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
  .threeBox {
    width: 100%;
    height: 730px;
    background-color: #d8e8f0;
    // opacity: 0.1;
    display: flex;
    justify-content: center;
    align-items: center;
    .pos {
      width: 1281px;
      height: 579px;
      // border: 1px solid red;
      .topBox {
        width: 100%;
        height: 84px;
        text-align: center;
        margin-bottom: 40px;
        h3 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 104, 183, 1);
          margin-bottom: 30px;
        }
        p {
          font-size: 19px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
      }
      .contentBox {
        text-align: center;
        h3 {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 104, 183, 1);
          margin-bottom: 28px;
        }
        p {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 30px;
        }
      }
      .bottomBox {
        display: flex;
        justify-content: space-around;
        margin-top: 15px;
        h3 {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(0, 104, 183, 1);
          line-height: 60px;
        }
        p {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 30px;
        }
        .left {
          flex: 1;
          text-align: right;
          margin-top: 25px;
        }
        .center {
          flex: 1;

          text-align: center;
        }
        .right {
          flex: 1;
          text-align: left;
          margin-top: 25px;
          p {
            &:nth-child(3) {
              margin-bottom: 31px;
            }
          }
        }
      }
    }
  }
  .fourBox {
    width: 100%;
    height: 730px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f1f6f7;
    .pos {
      width: 1288px;
      height: 403px;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;
      .left {
        padding: 42px 0 0 72px;
        .leftBox1 {
          width: 513px;
          height: 136px;
          // border: 1px solid red;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding-top: 20px;
          .leftBox1-a {
            display: flex;
            line-height: 42px;
            img {
              margin-right: 19px;
            }
            p {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
          }
        }
        .leftBox2 {
          width: 513px;
          height: 150px;
          // border: 1px solid red;
          display: flex;
          justify-content: center;
          align-items: center;
          .clickToWe {
            width: 440px;
            height: 110px;
            // border: 1px solid red;
            line-height: 110px;
            text-align: center;
            background-image: url('../../../../assets/WEBlueBgc.png');
            .WEtext {
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              cursor: pointer;
            }
          }
        }
      }
      .right {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/product/component/weie.vue